import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { userAPI, friendshipAPI } from '../api';
import { AuthContext } from '../AuthContext';
import { t } from '../i18n';

const InvitePage = () => {
  const { username } = useParams();
  const { user } = useContext(AuthContext);
  const [targetUser, setTargetUser] = useState(null);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (user && username === user.username) {
      navigate('/profile');
      return;
    }
    loadUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username]);

  const loadUserInfo = async () => {
    try {
      const response = await userAPI.getByUsername(username);
      setTargetUser(response.data);
    } catch (err) {
      setMessage(t('userNotFound'));
    }
  };

  const handleSendInvite = async () => {
    if (!user) {
      navigate('/login');
      return;
    }

    if (username === user.username) {
      // Sending invite to self should instead go to profile
      navigate('/profile');
      return;
    }

    try {
      await friendshipAPI.sendRequest(username);
      setMessage(t('friendRequestSentSuccessfully'));
      setTimeout(() => navigate('/friends'), 2000);
    } catch (err) {
      setMessage(err.response?.data?.error || t('failedToSendRequest'));
    }
  };

  if (!targetUser && !message) {
    return <div className="container">{t('loading')}</div>;
  }

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '500px', margin: '50px auto', textAlign: 'center' }}>
        <h1>{t('friendInvitation')}</h1>
        
        {message ? (
          <div style={{ padding: '20px' }}>
            <p>{message}</p>
          </div>
        ) : (
          <>
            <div style={{ padding: '20px' }}>
              <h2>{targetUser.username}</h2>
            </div>
            
            {user ? (
              <button 
                className="btn btn-primary" 
                onClick={handleSendInvite}
                style={{ fontSize: '18px', padding: '15px 30px' }}
              >
                {t('sendFriendRequest')}
              </button>
            ) : (
              <div>
                <p>{t('loginToSendFriendRequest')}</p>
                <button 
                  className="btn btn-primary" 
                  onClick={() => navigate('/login')}
                  style={{ marginRight: '10px' }}
                >
                  {t('login')}
                </button>
                <button 
                  className="btn btn-secondary" 
                  onClick={() => navigate('/register')}
                >
                  {t('register')}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default InvitePage;
